import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BarChartFill } from "react-bootstrap-icons";
import classNames from "classnames";
import OrganisationIcon from "../../../../assets/icons/sidebar/organisation-icon.svg";
import ProjectsIcon from "../../../../assets/icons/sidebar/projects-icon.svg";
import CropsIcon from "../../../../assets/icons/sidebar/crops-icon.svg";
// Contexts
import { useLayout } from "../../../context/LayoutContext";
// Components
import SidebarLink from "./components/SidebarLink";
// Assests
import Logo from "../../../../assets/img/logo.svg";
import { useUserInfoContext } from "../../../context/UserInfoContext";
import { getOrganizationDetails } from "../../../../helpers/api";
import { useOrganizationContext } from "../../../context/OrganizationContext";

interface MenuItem {
  id: number;
  label: string;
  link?: string;
  icon: JSX.Element;
  alternativeLink?: { label: string; link: string }[];
}
const MENUS: MenuItem[] = [
  {
    id: 0,
    label: "Projects",
    link: "/dashboard",
    icon: <img src={ProjectsIcon}></img>,
  },
  {
    id: 1,
    label: "Organisation",
    icon: <img src={OrganisationIcon}></img>,
    alternativeLink: [
      {
        label: "Current Available Organisation",
        link: "/organization",
      },
      {
        label: "Create New Organisation",
        link: "/register-organisation",
      },
      {
        label: "Create New Sub-Organisation",
        link: "/register-sub-organisation",
      },
    ],
  },
  {
    id: 3,
    label: "Crop Advisory",
    link: "/add-crops",
    icon: <img src={CropsIcon}></img>,
  },
];

const Sidebar: React.FC = () => {
  const { state } = useLayout();
  const { user }: any = useUserInfoContext();
  const userRole = user.role;
  const [filteredMenus, setFilteredMenus] = useState<MenuItem[]>([]);
  const { organization } = useOrganizationContext() as any;

  const getMenuBasedOnRole = (role: string) => {
    switch (role) {
      case "SUPERADMIN":
        return MENUS;
      default:
        return MENUS.filter((menu) => menu.id === 0);
    }
  };

  useEffect(() => {
    if (userRole !== undefined && userRole !== "") {
      setFilteredMenus(getMenuBasedOnRole(userRole));
    } else {
      window.location.reload();
    }
  }, [userRole]);
  // useEffect(() => {
  //   const role = user?.role || localStorage.getItem("userRole");
  //   if (role) {
  //     setUserRole(role);
  //   } else {
  //     console.warn("User role is not available");
  //   }
  // }, [user]);

  // useEffect(() => {
  //   if (userRole) {
  //     setFilteredMenus(getMenuBasedOnRole(userRole));
  //   }
  // }, [userRole]);

  return (
    <div className={classNames("sidebar", { active: state.isSidebarOpened })}>
      <div className="logo">
        <Link to="/">
          <img
            src={organization?.logoUrl || Logo}
            alt="AEPC Logo"
            className="img-fluid"
            style={{ width: "130px" }}
          />
        </Link>
      </div>
      <div className="list">
        {filteredMenus.map((link) => (
          <SidebarLink key={link.id} {...link} />
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
